<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :title="status?'查看用户':'编辑用户'"
       :close-on-click-modal="false"
      :visible.sync="editDialogVisible"
      width="30%"
      :before-close="closeEditDialog">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form" :disabled="status">
        <el-form-item label="用户名" prop="regName">
          <el-input v-model.trim="form.regName" autocomplete="off" placeholder="请输入用户名" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model.trim="form.realName" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="角色" prop="charactor">
          <el-select style="width:100%" v-model="form.charactor" :multiple="true">
            <el-option
              v-for="item in charactorOptions"
              :key="item.id"
              :label="item.charactor"
              :value="item.charactor">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="form.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="form.phone" autocomplete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <!-- <el-form-item label="分配产品" prop="distributionProduct">
          <el-select style="width:100%" v-model="form.distributionProduct" :multiple="true">
            <el-option
              v-for="item in productOptions"
              :key="item.id"
              :label="item.productName"
              :value="item.productName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建者" prop="createUser">
          <el-input v-model="form.createUser" autocomplete="off" placeholder="请输入创建者" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="form.createTime" autocomplete="off" placeholder="请输入创建时间" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
           <el-input v-model="form.remark" autocomplete="off"  placeholder="请输入备注" type="textarea" :rows="5" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="status===false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { emailVf, phoneVf } from '@/assets/js/validator'
import { editUser } from '@/api/user'
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      charactorOptions: [
        {
          id: 0,
          charactor: '董事长'
        },
        {
          id: 1,
          charactor: '厂家负责人'
        },
        {
          id: 2,
          charactor: '厂区经理'
        },
        {
          id: 3,
          charactor: '清洁工'
        }
      ],
      productOptions: [
        {
          id: 0,
          productName: '冰箱'
        },
        {
          id: 1,
          productName: '手机'
        },
        {
          id: 2,
          productName: '风扇'
        },
        {
          id: 3,
          productName: '空调'
        }
      ],
      form: {},
      rules: {
        regName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '姓名名不能为空', trigger: 'blur' }
        ],
        charactor: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        email: [
          { required: true, validator: emailVf, trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, validator: phoneVf, trigger: ['blur', 'change'] }
        ],
        distributionProduct: [
          { required: true, message: '请选择分配产品', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    console.log('this.editData', this.editData)
    this.form = Object.assign({}, this.editData)
    // 解决select设置多选(multiple) 触发formItem校验
    this.$set(this.form, 'charactor', [])
    this.$set(this.form, 'distributionProduct', [])
  },
  mounted () {

  },
  methods: {
    closeEditDialog () {
      this.$emit('closeEditDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.form)
        if (valid) {
          const params = {
            userId: this.form.userId,
            regName: this.form.regName,
            realName: this.form.realName,
            gender: this.form.gender,
            email: this.form.email,
            phone: this.form.phone,
            remark: this.form.remark
          }
          editUser(params).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              console.log(1)
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.$emit('closeEditDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
